export enum ButtonMode {
  Start = "start",
  Edit = "edit",
}
